export type ConversationPeer = {
  id: number
  name: string
  screenname?: string | null
  avatar_url?: string | null
}

export type Conversation = {
  conversation_id: number
  title: string | null
  is_group: number
  last_message_at: string | null
  last_body?: string | null
  last_sender_id?: number | null

  // ✅ receipts
  last_message_id?: number | null
  my_last_read_message_id?: number | null
  peer_last_read_message_id?: number

  // ✅ peer (1-1)
  peer?: ConversationPeer | null
}

export type Message = {
  message_id: number
  conversation_id: number
  sender_id: number
  body: string
  date_added: string
}

async function api<T>(url: string, opts: RequestInit & { userId: number }): Promise<T> {
  const res = await fetch(url, {
    ...opts,
    headers: {
      ...(opts.headers || {}),
      'x-user-id': String(opts.userId),
    },
    cache: 'no-store',
  })

  const json = await res.json()
  if (!res.ok || !json?.ok) {
    throw new Error(json?.error || 'API_ERROR')
  }
  return json as T
}

export async function fetchConversations(userId: number) {
  const json = await api<{ ok: true; conversations: Conversation[] }>('/api/inbox/conversations', {
    method: 'GET',
    userId,
  })
  return json.conversations
}

export async function fetchMessages(userId: number, conversationId: number) {
  const json = await api<{ ok: true; messages: Message[] }>(
    `/api/inbox/messages?conversationId=${encodeURIComponent(String(conversationId))}`,
    { method: 'GET', userId }
  )
  return json.messages
}
